import { createAction, handleActions } from 'redux-actions';

const setFormValue = createAction("MODALS/SUPPLIER/SET_FORM_VALUE", (key, value) => ({ key, value }));
const resetForm = createAction("MODALS/SUPPLIER/RESET_FORM");
const loadForm = createAction("MODALS/SUPPLIER/LOAD_FORM");

const defaultState = {
  company_name: '',
  trading_name: '',
  company_registration: '',
  vat_number: '',
  email: '',
  phone: '',
  website: '',
  address_line_1: '',
  address_line_2: '',
  city: '',
  county: '',
  postcode: '',
  country: 'United Kingdom',
  payment_terms: '',
  default_lead_time_days: null,
  default_currency: 'GBP',
  default_tax_rate: 20,
  credit_limit: null,
  account_number: '',
  notes: '',
  active: true,
};

const reducer = handleActions(
  {
    [setFormValue]: (state, action) => ({ ...state, [action.payload.key]: action.payload.value }),
    [resetForm]: () => defaultState,
    [loadForm]: (state, action) => ({ ...state, ...action.payload }),
  },
  defaultState
);

export { setFormValue, resetForm, loadForm, reducer };
